const NoteIcon = () => {
  return (
    <svg
      width={24}
      height={30}
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.03033 3.3983C1.03033 2.65604 1.63294 2.05432 2.37629 2.05432H21.7703C22.5136 2.05432 23.1162 2.65604 23.1162 3.3983V27.7732C23.1162 28.5155 22.5136 29.1172 21.7703 29.1172H2.37629C1.63294 29.1172 1.03033 28.5155 1.03033 27.7732V3.3983Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.10352e-05 3.45292C6.10352e-05 2.19334 1.02798 1.17224 2.29598 1.17224H21.7041C22.9721 1.17224 24.0001 2.19334 24.0001 3.45292V27.7194C24.0001 28.979 22.9721 30.0001 21.7041 30.0001H2.29598C1.02798 30.0001 6.10352e-05 28.979 6.10352e-05 27.7194V3.45292ZM2.29598 3.05761C2.07619 3.05761 1.89802 3.2346 1.89802 3.45292V27.7194C1.89802 27.9377 2.07619 28.1147 2.29598 28.1147H21.7041C21.9239 28.1147 22.1021 27.9377 22.1021 27.7194V3.45292C22.1021 3.23459 21.9239 3.05761 21.7041 3.05761H2.29598Z"
        fill="#2E3B54"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00714 8.45253C5.00714 8.16822 5.23924 7.93774 5.52556 7.93774L19.0654 7.93775C19.3517 7.93775 19.5838 8.16822 19.5838 8.45253C19.5838 8.73683 19.3517 8.96731 19.0654 8.96731L5.52556 8.96731C5.23924 8.96731 5.00714 8.73683 5.00714 8.45253Z"
        fill="#2E3B54"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00714 12.4232C5.00714 12.1389 5.2394 11.9084 5.52591 11.9084L16.2675 11.9084C16.554 11.9084 16.7863 12.1389 16.7863 12.4232C16.7863 12.7075 16.554 12.938 16.2675 12.938L5.52591 12.938C5.2394 12.938 5.00714 12.7075 5.00714 12.4232Z"
        fill="#2E3B54"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00714 16.3942C5.00714 16.1099 5.2394 15.8794 5.52591 15.8794L16.2675 15.8794C16.554 15.8794 16.7863 16.1099 16.7863 16.3942C16.7863 16.6785 16.554 16.909 16.2675 16.909L5.52591 16.909C5.2394 16.909 5.00714 16.6785 5.00714 16.3942Z"
        fill="#2E3B54"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00714 20.5131C5.00714 20.2288 5.23954 19.9983 5.52621 19.9983L17.7396 19.9983C18.0263 19.9983 18.2587 20.2288 18.2587 20.5131C18.2587 20.7974 18.0263 21.0279 17.7396 21.0279L5.52621 21.0279C5.23954 21.0279 5.00714 20.7974 5.00714 20.5131Z"
        fill="#2E3B54"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00714 24.4841C5.00714 24.1998 5.23954 23.9694 5.52621 23.9694L17.7396 23.9694C18.0263 23.9694 18.2587 24.1998 18.2587 24.4841C18.2587 24.7684 18.0263 24.9989 17.7396 24.9989L5.52621 24.9989C5.23954 24.9989 5.00714 24.7684 5.00714 24.4841Z"
        fill="#2E3B54"
      />
      <path
        d="M5.45422 0.747813C5.45422 0.334807 5.8024 0 6.2319 0H17.7675C18.197 0 18.5451 0.334807 18.5451 0.747813V4.42456C18.5451 4.83757 18.197 5.17237 17.7675 5.17237H6.2319C5.8024 5.17237 5.45422 4.83757 5.45422 4.42456V0.747813Z"
        fill="#ECBE6B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.09059 1.55171V3.62066H16.9088V1.55171H7.09059ZM6.2319 0C5.8024 0 5.45422 0.334807 5.45422 0.747813V4.42456C5.45422 4.83757 5.8024 5.17237 6.2319 5.17237H17.7675C18.197 5.17237 18.5451 4.83757 18.5451 4.42456V0.747813C18.5451 0.334807 18.197 0 17.7675 0H6.2319Z"
        fill="#2E3B54"
      />
    </svg>
  );
};

export default NoteIcon;
